import { assessmentType } from "../../components/constants/constants"
import { Col } from "reactstrap"
export const AssessmentDescription = ({ data }) => {
  return (
    <>
    <div
    className="border bg-white border-top-0 border-bottom-0 p-3 px-4 row"
    xs="1"
    sm="1"
    md="4"
  >
    <Col md>
      <div class="content-align-center">
      <span className="sg-time margin-0">{data.label}</span>
      </div>
    </Col>
    {data && data.assessment_type !== assessmentType.PLACEMENT ?(
      <Col md className="text-end">
       {/* <BookMarkButton /> */}
      </Col>
    ): null}
    
    </div>
    <p className="quiz-bottom-border mx-4"></p>
    </>
  )
}